import { render, staticRenderFns } from "./Receivables.vue?vue&type=template&id=0c26617d&scoped=true&"
import script from "./Receivables.vue?vue&type=script&lang=js&"
export * from "./Receivables.vue?vue&type=script&lang=js&"
import style0 from "./Receivables.vue?vue&type=style&index=0&id=0c26617d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c26617d",
  null
  
)

export default component.exports